import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IYearGroup } from "../../../Pages/Year group/IyearGroup";

export const ListyearGroupSlice = createSlice({
  name: "ListyearGroupSlice",
  initialState: {} as IReduxState<IYearGroup[]>,
  reducers: {
    listyearGroup: (state) => {
      state.isLoading = true;
    },
    successlistyearGroup: (state, action) => {

      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistyearGroup: (state, action) => {

      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistyearGroup,
  listyearGroup,
  successlistyearGroup,
} = ListyearGroupSlice.actions;

export default ListyearGroupSlice.reducer;
